import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../redux/features/blogs/blogsSlice";
import BlogGridItem from "./BlogItem";

export default function Blog() {
    const dispatch = useDispatch();
    const { isLoading, blogs, isError, error } = useSelector((state) => state.blogs);
    const { sortParam, filterParam } = useSelector((state) => state.filter);

    const sortBlogs = (a, b) => {
        switch (sortParam) {
            case "most_liked":
                return b.likes - a.likes;
            case "newest":
                return new Date(b.createdAt) - new Date(a.createdAt);
            default:
                return 0;
        }
    };

    const filterBlogs = (blog) => (filterParam === "saved" ? blog.isSaved : blog);

    useEffect(() => { dispatch(fetchBlogs()); }, [dispatch]);

    return (
        <div>
            <main className="post-container" id="lws-postContainer">
                {isLoading && <div> Loading... </div>}
                {isError && <div> {error} </div>}

                {!isLoading && !isError && blogs.length === 0 && (<div> No Blog Found </div>)}

                {!isLoading && !isError && blogs
                    .filter(filterBlogs)
                    .sort(sortBlogs)
                    .map((blog) => <BlogGridItem key={blog.id} blog={blog} />)}
            </main>
        </div>
    );
}
